import { parseStationTime, toStationWall } from './time';

const HOUR = 3600e3;
const DAY = 24 * HOUR;

export const PRESETS = ['8h', '24h', '3d'];
export const PRESET_MS = { '8h': 8 * HOUR, '24h': DAY, '3d': 3 * DAY };
export const CUSTOM_MAX_MS = 5 * DAY;
const URL_WALL_RE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;

/** 'YYYY-MM-DDTHH:mm' (datetime-local / URL form, Belgrade wall) → epoch ms. */
export function wallInputToMs(s) {
    if (typeof s !== 'string' || !URL_WALL_RE.test(s)) return NaN;
    return parseStationTime(`${s.replace('T', ' ')}:00`);
}

export function parseRangeFromUrl(searchParams) {
    const raw = searchParams.get('range');
    if (PRESETS.includes(raw)) return { range: raw };
    if (raw === 'custom') {
        const fromMs = wallInputToMs(searchParams.get('from') || '');
        const toMs = wallInputToMs(searchParams.get('to') || '');
        if (!Number.isNaN(fromMs) && !Number.isNaN(toMs) && fromMs < toMs) return { range: 'custom', fromMs, toMs };
    }
    return { range: '8h' };
}

export function rangeToUrlParams(state) {
    if (state.range !== 'custom') return { range: state.range };
    return {
        range: 'custom',
        from: toStationWall(state.fromMs, 'YYYY-MM-DDTHH:mm'),
        to: toStationWall(state.toMs, 'YYYY-MM-DDTHH:mm'),
    };
}

export function validateCustomRange(fromMs, toMs, nowMs) {
    if (!(fromMs < toMs)) return { ok: false, reason: 'fromAfterTo' };
    if (toMs - fromMs > CUSTOM_MAX_MS) return { ok: false, reason: 'spanTooLarge' };
    if (toMs > nowMs) return { ok: false, reason: 'inFuture' };
    return { ok: true };
}

export function resolveWindow(state, nowMs) {
    if (state.range === 'custom') return { fromMs: state.fromMs, toMs: state.toMs };
    return { fromMs: nowMs - PRESET_MS[state.range], toMs: nowMs };
}

export function formatRangeLabel(fromMs, toMs) {
    return `${toStationWall(fromMs, 'DD MMM HH:mm')} → ${toStationWall(toMs, 'DD MMM HH:mm')}`;
}
